'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define(['app'], function (app) {

  var announcerHTML = '\n        <div class="accessibleAnnouncer">\n          <div id="accessible-announcer-assertive-1" class="srf-hide" role="log" aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>\n          <div id="accessible-announcer-assertive-2" class="srf-hide" role="log" aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>\n          <div id="accessible-announcer-polite-1" class="srf-hide" role="log" aria-live="polite" aria-relevant="additions" aria-atomic="true"></div>\n          <div id="accessible-announcer-polite-2" class="srf-hide" role="log" aria-live="polite" aria-relevant="additions" aria-atomic="true"></div>\n        </div>\n    ';

  var AccessibleAnnouncer = function () {
    function AccessibleAnnouncer() {
      _classCallCheck(this, AccessibleAnnouncer);

      this.init();
    }

    _createClass(AccessibleAnnouncer, [{
      key: 'init',
      value: function init() {
        this.politeMessage = '';
        this.assertiveMessage = '';
        this.messages = {
          assertiveMessage1: '',
          assertiveMessage2: '',
          politeMessage1: '',
          politeMessage2: ''
        };

        this.setAlternatePolite = false;
        this.setAlternateAssertive = false;

        document.body.insertAdjacentHTML('beforeend', announcerHTML);

        app.subscribe('accessibility/announce', this.announce());
      }
    }, {
      key: 'announce',
      value: function announce() {
        var _this = this;

        var SELF = this;
        return function (level, announcement) {

          if (!document.querySelector('.accessibleAnnouncer')) {
            SELF.init();
          }

          if (level === 'polite' && _this.politeMessage !== announcement) {
            SELF.messages.politeMessage1 = SELF.setAlternatePolite ? '' : announcement;
            SELF.messages.politeMessage2 = SELF.setAlternatePolite ? announcement : '';
            SELF.setAlternatePolite = !SELF.setAlternatePolite;
            document.getElementById('accessible-announcer-polite-1').innerText = SELF.messages.politeMessage1;
            document.getElementById('accessible-announcer-polite-2').innerText = SELF.messages.politeMessage2;
            SELF.politeMessage = announcement;
          }

          if (level === 'assertive' && SELF.assertiveMessage !== announcement) {
            SELF.messages.assertiveMessage1 = SELF.setAlternateAssertive ? '' : announcement;
            SELF.messages.assertiveMessage2 = SELF.setAlternateAssertive ? announcement : '';
            SELF.setAlternateAssertive = !SELF.setAlternateAssertive;
            document.getElementById('accessible-announcer-assertive-1').innerText = SELF.messages.assertiveMessage1;
            document.getElementById('accessible-announcer-assertive-2').innerText = SELF.messages.assertiveMessage2;
            SELF.assertiveMessage = announcement;
          }
        };
      }
    }]);

    return AccessibleAnnouncer;
  }();

  return new AccessibleAnnouncer();
});
//# sourceMappingURL=accessibilityAnnouncer.js.map
